import {
  HHChip,
  HHStack,
  HHTypography,
} from '@hinge-health/react-component-library';

interface SubmissionStatusCellProps {
  submissionStatus?: string;
}
export const SubmissionStatusCell = ({
  submissionStatus,
}: SubmissionStatusCellProps): JSX.Element => {
  const getStatusColor = (
    status: string,
  ): 'primary' | 'error' | 'warning' | 'success' | 'neutral' | 'default' => {
    switch (status) {
      case 'submitted':
        return 'primary';
      case 'denied':
        return 'error';
      case 'duplicate':
        return 'default';
      case 'accepted':
        return 'success';
      case 'void':
        return 'neutral';
      case 'unknown':
        return 'neutral';
      case 'reversal':
        return 'warning';
      default:
        return 'neutral';
    }
  };

  return (
    <HHStack direction="column">
      <HHTypography hhVariant="caption">
        {submissionStatus ? (
          <HHChip
            hhVariant="variant-bypass"
            color={getStatusColor(submissionStatus)}
            size="small"
            label={submissionStatus.toUpperCase()}
          />
        ) : (
          <HHTypography hhVariant="caption">--</HHTypography>
        )}
      </HHTypography>
    </HHStack>
  );
};
